import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const DocumentReadabilityCallout = ({
  targetRef,
  classes,
  position,
  children,
}) => {
  const calloutRef = useRef(null);
  const [styles, setStyles] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (targetRef.current && calloutRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      setStyles({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
      });
    }
  }, [targetRef]);

  return ReactDOM.createPortal(
    <div
      ref={calloutRef}
      data-testid="callout"
      className={`callout ${classes}`}
      style={{
        position: "absolute",
        top: position ? position.y : styles.top,
        left: position ? position.x : styles.left,
      }}
    >
      <div className="callout_bead" />
      {children}
    </div>,
    document.body
  );
};

export default DocumentReadabilityCallout;

DocumentReadabilityCallout.propTypes = {
  targetRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  classes: PropTypes.string,
  position: PropTypes.oneOfType([PropTypes.object]),
};
